export default __webpack_public_path__ + "static/media/search.a2bb5258.svg";